/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { IRenderer, RENDERER_TYPE } from 'pixi.js-legacy';

export class RendererInfo {
	public renderer: IRenderer;

	constructor(renderer?: IRenderer) {
		this.renderer = renderer;
	}

	public isWebGL(): boolean {
		return this.renderer.type === RENDERER_TYPE.WEBGL;
	}
}

export const planRendererInfo: RendererInfo = new RendererInfo();
